/** Human labels for governance / quota feature keys. */
export const TUTOR_EXPERIENCE_LABELS: Record<string, string> = {
  live_ai_tutor: 'Live AI Pool',
  ai_lesson_tutor: 'AI Lesson Tutor',
  communication_tutor: 'Communication Tutor',
  scenario_conversation_tutor: 'Scenario Conversation',
  picture_talk_tutor: 'Picture Talk',
};

export function labelForTutorFeature(featureName: string): string {
  return TUTOR_EXPERIENCE_LABELS[featureName] ?? featureName;
}

export function utilizationPct(used: number, allocated: number | null | undefined): number | null {
  if (allocated == null || allocated <= 0) return null;
  return Math.min(100, Math.round((100 * used) / allocated));
}
